module.exports = __webpack_public_path__ + "static/img/game-logo-m.f686ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-m.png
// module id = NDk+
// module chunks = 0 1 2 3 4 5 6